<template>
  <div class="intro-concept-content-wrapper" id="identidade-visual-cores-introducao" data-search-anchor>
    <div class="intro-concept-content">
      <h1 class="intro-concept-title">{{ introTitle }}</h1>
      <div class="description-concept-content">
        <p class="intro-concept-description">{{ introDescription }}</p>
      </div>
    </div>
    <div class="card-item-concept-content">
      <div class="card-item-concept-color" :style="{ backgroundImage: `url(${logosImageSrc})` }"></div>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import ColorPageMixin from '@/mixins/color-page-mixin'
import { ColorPageStore } from '@/store/visual-identity-page/color-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class ColorsConceptSection extends Mixins(ColorPageMixin) {
  colorPageStore: PageStoreContract = getModule(ColorPageStore, this.$store)

  get introTitle(): string {
    return this.getElementText(2, 0)
  }

  get introDescription(): string {
    return this.getElementText(2, 1)
  }

  get logosImageSrc(): string {
    return this.getElementMedia(2, 1)
  }

  async getColorPage(): Promise<void> {
    await this.colorPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.colorPageStore.isLoading) {
      await this.getColorPage()
    }
  }
}
</script>

<style lang="scss">
.intro-concept-content-wrapper {
  justify-items: center;
  width: 100%;
  max-width: 1032px;
}

.intro-concept-content {
  display: grid;
  grid-template-columns: 50% 48.5%;
  width: 100%;
  max-width: 1032px;
}

.intro-concept-title{
  white-space: pre-line;
}

.description-concept-content {
  width: 488px;
}

.intro-concept-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
}

.card-item-concept-content {
  width: 100%;
  max-width: 1032px;
  padding-top: 2rem;
}

.card-item-concept-color {
  position: relative;
  max-width: 1032px;
  width: 98%;
  height: 82px;
  background-size: cover;
  background-position: center;  
}
</style>
